const sizeValueToCss = (value: string | number): string =>
  typeof value === 'string'
    ? value
    : value < 1 && value > 0
    ? `${value * 100}%`
    : `${value}px`

export default sizeValueToCss
